<template>
  <div class="task-card">
    <a v-on:click="show(task.id)" class="task-card-a">
      <b-card>
        <b-card-text>
          <div><em class="text-muted">#{{ task.id }}</em></div>
          <div>{{ task.content }}</div>
          <!--<div v-if="task.due_date">-->
          <!--  <small :class="{-->
          <!--    'text-danger': task.expire === 'expired',-->
          <!--    'text-success': task.expire === 'today',-->
          <!--    'text-warning': task.expire === 'tomorrow',-->
          <!--  }">до {{ dueDateString }}</small>-->
          <!--</div>-->

          <b-card v-if="task.deal" bg-variant="light" class="task-deal-link">
            <b-card-text>
              <div class="source-link">
                <b-icon-link class="mr-1"></b-icon-link>
                <router-link :to="{ name: 'Deal', params: { id: task.deal.id }}">Сделка #{{ task.deal.id }}</router-link>
                <div class="p-2">{{ task.deal.title }}</div>
              </div>
            </b-card-text>
          </b-card>

          <b-card v-if="task.contact" bg-variant="light" class="task-contact-link">
            <b-card-text>
              <address>
                <div><strong>{{ task.contact.last_name + ' ' + task.contact.first_name }}</strong></div>
                <div
                  v-if="task.contact.email && task.contact.email.trim().length>1"
                >
                  <b-icon-envelope size="sm" class="mr-1"></b-icon-envelope>
                  <a :href="'mailto:'+task.contact.email">{{ task.contact.email }}</a></div>
                <div
                  v-if="task.contact.phone && task.contact.phone.trim().length>1"
                >
                  <b-icon-headphones size="sm" class="mr-1"></b-icon-headphones>
                  <span>{{ task.contact.phone }}</span>
                </div>
              </address>
            </b-card-text>
          </b-card>

          <!--<div v-if="task.responsible" bg-variant="light" class="task-responsible-link">-->
          <!--  <small>Ответственный: {{ task.responsible.last_name }} {{ task.responsible.first_name }}</small>-->
          <!--</div>-->

        </b-card-text>
      </b-card>
    </a>
  </div>
</template>

<script>
export default {
  name: 'task-card',
  props: {
    task: Object
  },
  computed: {
    dueDateString: function () {
      if (this.task.due_date) {
        const datetime = new Date(this.task.due_date);

        return datetime.toLocaleString();
      }
      return false;
    }
  },
  methods: {
    show(id) {
      this.$emit('showTarget', id)
    },
  }
}
</script>

<style scoped lang="scss">
.card-body {
  padding: 0.5rem;
}

.task-contact-link,
.task-deal-link,
.task-company-link,
.task-responsible-link, {
  margin: 6px 0 0 0;

  .card-body {
    padding: 0.25rem;

    .card-text {
      font-size: 0.9rem;
    }
  }
}

.task-card-a {
  color: inherit;
  text-decoration: inherit;
  background-color: inherit;
}
</style>
